"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferType = void 0;
const core_1 = require("@angular/core");
let OfferType = class OfferType {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], OfferType.prototype, "offer", void 0);
OfferType = __decorate([
    (0, core_1.Component)({
        selector: 'offer-type',
        template: `
    {offer.type, select,
      R {Leasingangebot mit Restwertabrechnung}
      L {Leasingangebot mit Kilometerabrechnung}
      F {Finanzierungsangebot}
      C {Barpreisangebot}
    }
  `,
    })
], OfferType);
exports.OfferType = OfferType;
